var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { apiCardUpload } from '@/actions/CardActionsTs/create';
import { apiCreateFileUpload } from '@/actions/FileActionsTs';
import { RegistrationCardView } from '@/components/pages/card/RegistrationCardView';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { cardComplete } from '@/utils/router/links';
/**
 * 名刺登録
 */
export const RegistrationCardPage = (props) => {
    const { cardChecked, token } = props;
    const history = useNavigate();
    const dispatch = useDispatch();
    const userName = useMemo(() => {
        if (!cardChecked) {
            return '';
        }
        const { first_name: firstName, last_name: lastName } = cardChecked;
        return ((lastName || firstName) && `${lastName} ${firstName}`) || '';
    }, [cardChecked]);
    /**
     * 送信処理
     */
    const uploadCard = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const file = (_b = (_a = values.upload_file) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.call(_a, 0);
        if (!file) {
            return undefined;
        }
        // 画像アップロード
        const formData = new FormData();
        formData.append('upload_file', file, file.name);
        const { payload } = yield wrapDispatch(dispatch, apiCreateFileUpload({ json: formData }, {}));
        if (!(payload === null || payload === void 0 ? void 0 : payload.id)) {
            return undefined;
        }
        // 送信
        yield wrapDispatch(dispatch, apiCardUpload({ json: { file_id: payload.id }, path: { token } }, {}));
        // 成功時の処理(完了画面へ遷移)
        history.push(cardComplete());
        return undefined;
    }), [dispatch, history, token]);
    return _jsx(RegistrationCardView, { onSubmit: uploadCard, userName: userName });
};
